import React from 'react'
import cx from 'classnames'
import { BtnV2, color, Icon, isAndroid, isApple, l } from '@manychat/manyui'

import { analyticsService } from 'utils/services/analytics'

import bannerImage from './img/banner_image.png'

import cm from './MobileBanner.module.css'

const ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.manychat'
const APPLE_APP_LINK = 'https://apps.apple.com/am/app/manychat/id1460129210'

interface MainScreenProps {
  onClose: () => void
}

export const MainScreen = ({ onClose }: MainScreenProps) => {
  const handleClickOpenAppButton = () => {
    analyticsService.sendEvent('MOBILE_BANNER_DOWNLOAD_APP_CLICK', {
      isAndroid,
      isApple,
      novemberExperiment: true,
    })

    let link = ''
    if (isAndroid) link = ANDROID_APP_LINK
    if (isApple) link = APPLE_APP_LINK

    window.open(link, '_blank')
  }

  return (
    <>
      <Icon.Close size={24} className={cm.closeIcon} onClick={onClose} color={color.icon.subtle} />
      <img width={296} src={bannerImage} className={cx(cm.bannerImage)} alt="Manychat mobile app" />
      <h1 className="text-center m-t-0">
        {l.translate('Get better experience with Manychat App')}
      </h1>
      <p className="text-center m-b-xl">
        {l.translate(
          'At the moment, the web version is not adapted for comfortable work on a mobile device. Please use the mobile app. ',
        )}
      </p>
      <BtnV2 variant="primary" fullWidth onClick={handleClickOpenAppButton}>
        {l.translate('Open Manychat App')}
      </BtnV2>
    </>
  )
}
